module.exports = __webpack_public_path__ + "static/media/Funder2.c4fc03e0.png";